import {
  applyFilters,
  getFilterObject,
} from "../../_global/js/search/apply_filters";

(function () {
  /**
   * The Enhanced Search
   *
   * @module enhancedSearch
   */

  const facetsComponent = document.querySelector(".qld__search__facets");
  const facetsButton = document.querySelector(
    ".qld__search__facets > .qld__search__facets__toggle",
  );
  const facetsBody = document.getElementById("search__facets");

  /**
   * Check if the enhanced search class is present on the page
   */
  function isEnhancedSearchPage() {
    return document.querySelector(".enhanced-search") !== null;
  }

  if (isEnhancedSearchPage()) {
    console.log("isEnhancedSearchPage");

    let enhancedSearch = {};
    let windowWidth = window.innerWidth;

    // Object to store current filter states
    let currentFilterStates = {};

    /**
     * Initialise the Enhanced Search listeners for keyboard navigation
     *
     * @memberof module:enhancedSearch
     */
    enhancedSearch.init = function () {
      let queryParam = new URLSearchParams(window.location.search).get("query");

      if (queryParam) {
        highlightSearchTerm(queryParam);
      }

      if (document.querySelector(".qld__search__facet-list")) {
        // Set view of the facets based on initial window size
        if (windowWidth > 991) {
          setDesktopView();
        } else {
          setMobileView();
        }

        window.addEventListener("resize", debounce(checkWindowResize, 100));
        let facetInputs = document.querySelectorAll(
          ".qld__search__facet-list .qld__search__facet-input",
        );

        const checkedFacets = [];

        // Listen for changes on facet inputs, but only update the state object
        for (let i = 0; i < facetInputs.length; i++) {
          facetInputs[i].addEventListener("change", function () {
            const filterQuery = this.dataset.querystring;

            // Set the checked state for the current filter query
            currentFilterStates[filterQuery] = this.checked;

            // Update the checkedFacets array
            if (this.checked) {
              // Add to array if checked
              if (!checkedFacets.includes(filterQuery)) {
                checkedFacets.push(filterQuery);
              }
            } else {
              // Remove from array if unchecked
              const index = checkedFacets.indexOf(filterQuery);
              if (index > -1) {
                checkedFacets.splice(index, 1);
              }
            }
          });

          // Add keydown event to handle Enter key for keyboard navigation
          facetInputs[i].addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
              this.checked = !this.checked; // Toggle checkbox state
              this.dispatchEvent(new Event("change")); // Trigger change event
            }
          });
        }

        // Add event listener to the apply filters button
        let applyFiltersButton = document.querySelector(
          ".qld__btn.qld__apply-filters__btn",
        );
        if (applyFiltersButton) {
          applyFiltersButton.addEventListener("click", function (event) {
            event.preventDefault();

            // ** Collect all filters dynamically from the DOM **
            const facetLists = document.querySelectorAll(
              ".qld__search__facet-list",
            ); // Get all elements
            const allFilters = []; // Initialize an array to collect all filters

            facetLists.forEach((facetList) => {
              const currentFilters = getFilterObject(facetList); // Get filters for each facet list
              allFilters.push(...currentFilters); // Spread current filters into the allFilters array
            });

            // ** Preserve the original search term **
            const searchQuery = new URLSearchParams(window.location.search).get(
              "query",
            );
            if (searchQuery) {
              // Append the search keyword to the filters
              allFilters.push(`query=${encodeURIComponent(searchQuery)}`);
            }
            // **

            // Apply filters using the combined array of filters
            applyFilters(allFilters);
          });
        }

        let accordionButtons = document.querySelectorAll(
          ".qld__search__facet-title.qld__accordion__title",
        );

        if (accordionButtons.length > 1) {
          document
            .querySelector(
              ".qld__search__facets-title-wrap .qld__search__toggle-all",
            )
            .classList.remove("qld__search__toggle-all--hide");
        }

        let selectElement = document.querySelector(".qld__resources__select");

        if (selectElement) {
          selectElement.addEventListener("change", function () {
            let selectedOption = this.options[this.selectedIndex];
            let filterQuery = selectedOption.dataset.queryparam;
            updateLanguageFilters(filterQuery, true);
          });
        }

        let toggleButtons = document.querySelectorAll(
          ".qld__search__facet-list .qld__search__facet-button--toggle",
        );
        if (toggleButtons) {
          initializeFacetListToggleButtons(toggleButtons);
        }

        let filterCloseButtons = document.querySelectorAll(
          ".qld__search__filters-list .qld__tag--filter-close",
        );
        if (filterCloseButtons) {
          for (let i = 0; i < filterCloseButtons.length; i++) {
            filterCloseButtons[i].addEventListener("click", (event) => {
              const filterQuery = event.currentTarget.dataset.querystring;
              updateFilters(filterQuery, false);
            });
          }
        }

        // Select all buttons with class 'qld__btn' and 'qld__btn--tertiary'
        let clearFilterTagButtons = document.querySelectorAll(
          ".qld__btn.qld__btn--tertiary",
        );

        if (clearFilterTagButtons.length) {
          // Function to clear all filters and reload page without query parameters
          const clearFilters = () => {
            // Redirect to the page without any query parameters
            window.location.href = `${window.location.origin}${window.location.pathname}?query=${queryParam}`;
          };

          // Attach event listeners to each 'clear all' button
          clearFilterTagButtons.forEach((button) => {
            button.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                clearFilters();
              }
            });

            button.addEventListener("click", () => {
              clearFilters();
            });
          });
        }
      }
    };

    function highlightSearchTerm(queryParam) {
      let pageContent = document.querySelectorAll(
        ".qld__search__result-header a, .qld__search__result-header .qld__breadcrumbs li, .qld__search__result-summary",
      );

      for (let i = 0; i < pageContent.length; i++) {
        let content = pageContent[i].textContent;
        let wrappedContent = content.replace(
          new RegExp(queryParam, "gi"),
          "<strong>$&</strong>",
        );

        if (content !== wrappedContent) {
          pageContent[i].innerHTML = wrappedContent;
        }
      }
    }

    function initializeFacetListToggleButtons(toggleButtons) {
      for (let i = 0; i < toggleButtons.length; i++) {
        let facetList = toggleButtons[i].closest(".qld__search__facet-list");
        let listItems = facetList.querySelectorAll("li");

        // Initially hide items beyond the 8th
        if (listItems.length >= 8) {
          hideAdditionalFacetListItems(listItems);

          toggleButtons[i].addEventListener("click", function () {
            toggleFacetListItems(toggleButtons[i], listItems);
          });
        } else {
          toggleButtons[i].classList.add("hidden");
        }
      }
    }

    function hideAdditionalFacetListItems(listItems) {
      if (listItems.length > 8) {
        for (let i = 8; i < listItems.length; i++) {
          listItems[i].classList.add("hidden");
        }
      }
    }

    function toggleFacetListItems(button, listItems) {
      const isShowingAll = button.classList.contains("showing-all");

      if (isShowingAll) {
        // Currently showing all items - hide extras and update button
        for (let i = 8; i < listItems.length; i++) {
          listItems[i].classList.add("hidden");
        }
        button.firstChild.nodeValue = "Show all";
        button.classList.remove("qld__search__facet-button--hide");
        button.classList.add("qld__search__facet-button--show");
      } else {
        // Currently showing less items - show all and update button
        for (let i = 8; i < listItems.length; i++) {
          listItems[i].classList.remove("hidden");
        }
        button.firstChild.nodeValue = "Show less";
        button.classList.remove("qld__search__facet-button--show");
        button.classList.add("qld__search__facet-button--hide");
      }

      // Toggle class to reflect current state
      button.classList.toggle("showing-all");
    }

    function updateFilters(filterQuery, state) {
      let currentQuery = window.location.search.replace("?", "").split("&");

      if (state) {
        currentQuery.push(filterQuery);
      }

      currentQuery.forEach(function (query, index) {
        if (query.indexOf("start_rank") > -1) {
          currentQuery.splice(index, 1);
        }

        if (!state) {
          if (query === filterQuery) {
            currentQuery.splice(index, 1);
          }
        }
      });

      window.location.href =
        window.location.pathname + "?" + currentQuery.join("&");
    }

    function updateLanguageFilters(filterQuery, state) {
      let currentQuery = window.location.search.replace("?", "").split("&");
      if (state) {
        let filterExists = false;
        currentQuery.forEach(function (query, index) {
          if (query.startsWith(filterQuery.split("=")[0])) {
            currentQuery[index] = filterQuery;
            filterExists = true;
          }
        });
        if (!filterExists) {
          currentQuery.push(filterQuery);
        }
      } else {
        currentQuery.forEach(function (query, index) {
          if (query.startsWith(filterQuery.split("=")[0])) {
            currentQuery.splice(index, 1);
          }
        });
      }
      window.location.href =
        window.location.pathname + "?" + currentQuery.join("&");
    }

    function checkWindowResize() {
      windowWidth = window.innerWidth;

      if (windowWidth > 991) {
        setDesktopView();
      } else {
        setMobileView();
      }
    }

    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    function setMobileView() {
      const facetListItems = document.querySelectorAll(
        ".qld__search__facet-list .qld__search__facet-title",
      );

      for (let i = 0; i < facetListItems.length; i++) {
        facetListItems[i].classList.add("qld__search__facet-title--mobile");
      }

      facetsButton.style.display = "block";
      facetsComponent.classList.add("qld__accordion");
    }

    function setDesktopView() {
      facetsButton.style.display = "none";
      facetsComponent.classList.remove("qld__accordion");
      facetsBody.classList.remove("qld__accordion--closed");
      facetsBody.classList.add("qld__accordion--open");
    }

    document.addEventListener("DOMContentLoaded", function () {
      enhancedSearch.init();
    });
  }
})();
